import { createAction, props } from '@ngrx/store';
import { InsuranceCarrier } from '@core/models/insurance-carrier';
import { HttpErrorResponse } from '@angular/common/http';
import { CustomError } from '@orthofi/ngx-error-handler';

// import { InsuranceCarrier } from './insurance-carrier.model';

/** Trigger an event for loading the carrier list from the API. */
export const loadInsuranceCarriers = createAction(
  '[InsuranceCarrier/API] Load InsuranceCarriers'
);

/** Trigger an event for updating the state with the carrier list. */
export const loadInsuranceCarriersSuccess = createAction(
  '[InsuranceCarrier/API] Load InsuranceCarriers Succeeded',
  props<{ insuranceCarriers: InsuranceCarrier[] }>()
);

/**
 * Trigger an event for updating the state when there was an error retrieving 
 * the carrier list.
 */
export const loadInsuranceCarriersFail = createAction(
  '[InsuranceCarrier/API] Load InsuranceCarriers Failed',
  props<{ error: Error | HttpErrorResponse | CustomError }>()
);
